import GaEvent from './GaEvent';

export default class ContactClickedGaEvent extends GaEvent {
  constructor() {
    super('contact_clicked');
  }
}
